import styled from "@emotion/styled";
import { FOOTER_HEIGHT } from "../note-preview-container.style";

export const StyledFooter = styled.div`
  background-color: ${({ theme }) => theme.colors.surface.previewHeader};
  height: ${FOOTER_HEIGHT};
  padding: ${({ theme }) => theme.spacing["4"]} ${({ theme }) => theme.spacing["4"]};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.medium};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius.medium};
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["1"]};
`;

export const StyledFooterTitle = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: ${({ theme }) => theme.lineHeights["text-s"]};
  font-size: ${({ theme }) => theme.fontSizes["paragraph-s"]};
  font-weight: ${({ theme }) => theme.fontWeights.smedium};
  color: ${({ theme }) => theme.colors.text.contrast};
  text-align: left;
`;

export const StyledFooterMetadata = styled.div`
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  line-height: ${({ theme }) => theme.lineHeights["text-xs"]};
  color: ${({ theme }) => theme.colors.text.primary};
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
